// constants.js
// -- To store all the hard code strings

export const STRINGS = {
    SIGN_IN_HEADING: "Sign In",
    EMAIL_LABEL: "Email",
    PASSWORD_LABEL: "Password",
    FORGOT_PASSWORD_TEXT: "Forgot Password?",
    SIGN_IN_BUTTON_TEXT: "Sign In",
    SIGN_UP_LINK_TEXT: "Don't have an account? Sign Up",
    PASSWORD_LENGTH_ERROR_MESSAGE: "Password must be at least 8 characters long"
  };
  